export default __webpack_public_path__ + "static/gq-d74deb4bba51b1c9f9b92fa4396856e2.svg";